import {
    apiRequest,
    riwayatjabatanDetail
} from "../../../../../services/adapters/kepegawaian/riwayatjabatanService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatjabatanDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository